import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LayoutDashboard, FileText, MessageSquare, ShoppingBag, Users, Calendar, LogOut, ArrowLeft } from 'lucide-react';

const navItems = [
  { path: '/admin', label: 'Dashboard', icon: LayoutDashboard },
  { path: '/admin/content', label: 'Content', icon: FileText },
  { path: '/admin/inquiries', label: 'Inquiries', icon: MessageSquare },
  { path: '/admin/orders', label: 'Orders', icon: ShoppingBag },
  { path: '/admin/waitlist', label: 'Waitlist', icon: Users },
  { path: '/admin/events', label: 'Events', icon: Calendar },
];

export const AdminLayout = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  return (
    <div className="min-h-screen flex bg-gray-50" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="w-64 bg-[#3A1F3D] text-white flex flex-col flex-shrink-0">
        <div className="p-6 border-b border-white/10">
          <Link to="/admin" data-testid="admin-sidebar-logo">
            <img src="/images/Logo/Natasha Simone website (4).png" alt="Natasha Simone" className="h-8 w-auto brightness-0 invert mb-3" />
          </Link>
          <p className="text-xs uppercase tracking-widest text-[#E84993] mb-1">Admin Panel</p>
          <p className="text-sm text-gray-400 truncate">{user?.email}</p>
        </div>

        <nav className="flex-1 py-4 space-y-1 px-3">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`admin-nav-${item.label.toLowerCase()}`}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  active
                    ? 'bg-[#E84993]/20 text-[#E84993]'
                    : 'text-gray-400 hover:text-white hover:bg-white/5'
                }`}
              >
                <Icon className="w-5 h-5" />
                {item.label}
              </Link>
            );
          })}
        </nav>

        <div className="p-3 space-y-1 border-t border-white/10">
          <Link
            to="/"
            className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm text-gray-400 hover:text-white hover:bg-white/5 transition-colors"
            data-testid="admin-nav-site"
          >
            <ArrowLeft className="w-5 h-5" />
            View Site
          </Link>
          <button
            onClick={logout}
            className="flex items-center gap-3 px-4 py-3 rounded-lg text-sm text-gray-400 hover:text-red-400 hover:bg-white/5 transition-colors w-full"
            data-testid="admin-logout-btn"
          >
            <LogOut className="w-5 h-5" />
            Logout
          </button>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 overflow-auto">
        <div className="p-8 max-w-7xl">{children}</div>
      </main>
    </div>
  );
};
